import { FC } from "react";

import { ProductTabSettings } from "@/components/web-experience/product-tab/product-tab-settings";
import { ProductTabOptions, SKUPageContentTabType } from "@/data/types";

import { CMSTab } from "./cms-tab";
import { CMSTabProvider } from "./cms-tab-context";

type Props = {
  index: number;
  options: ProductTabOptions;
};

export const CMSProductTab: FC<Props> = ({ index, options }) => (
  <CMSTabProvider tabType={SKUPageContentTabType.PRODUCT_TAB} tabIndex={index}>
    <CMSTab options={options}>
      <ProductTabSettings />
    </CMSTab>
  </CMSTabProvider>
);
